(() => {
  const drawer = document.getElementById('OmniCartDrawer');
  const backdrop = document.querySelector('.omni-cart-backdrop');
  const roots = () => Array.from(document.querySelectorAll('[data-omni-cart-ui]'));
  const routeRoot = window.Shopify?.routes?.root || '/';
  let lastFocus = null;
  let lastCart = null;
  let busy = false;
  let savedOverflow = '';
  const emit = (name, detail = {}) => window.dispatchEvent(new CustomEvent('omni:event', { detail: { name, ...detail } }));
  const units = cents => Number(cents || 0) / 100;
  const money = (cents, currency = 'MXN') => new Intl.NumberFormat('es-MX', { style: 'currency', currency, minimumFractionDigits: Number(cents) % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(units(cents));
  const isClub = item => Boolean(item?.selling_plan_allocation?.selling_plan?.id);
  const purchaseTypes = cart => [...new Set((cart.items || []).map(item => isClub(item) ? 'OMNICLUB' : 'ONE_TIME'))];
  const codes = cart => (cart?.discount_codes || []).filter(code => code.applicable).map(code => code.code);
  const same = (a, b) => String(a).toUpperCase() === String(b).toUpperCase();
  const safeUrl = (value, fallback) => {
    try {
      const url = new URL(value, location.origin);
      return ['https:', 'http:'].includes(url.protocol) ? url.href : fallback;
    } catch { return fallback; }
  };
  function node(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }
  function setCount(cart) {
    document.querySelectorAll('[data-omni-cart-count]').forEach(element => {
      element.textContent = cart.item_count || 0;
      element.hidden = !cart.item_count;
    });
  }
  function setExpanded(value) {
    document.querySelectorAll('[data-omni-cart-open]').forEach(element => element.setAttribute('aria-expanded', String(value)));
  }
  function focusable() {
    return drawer ? Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(element => element.getClientRects().length && !element.closest('[hidden]')) : [];
  }
  function close() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (backdrop) backdrop.hidden = true;
    document.documentElement.style.overflow = savedOverflow;
    setExpanded(false);
    if (lastFocus?.isConnected) lastFocus.focus();
  }
  function open() {
    if (!drawer) return;
    if (drawer.getAttribute('aria-hidden') !== 'false') {
      lastFocus = document.activeElement;
      savedOverflow = document.documentElement.style.overflow;
    }
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    setExpanded(true);
    (drawer.querySelector('[data-omni-cart-close]') || drawer).focus();
  }
  function errorMessage(message, source) {
    const root = source?.closest('[data-omni-cart-ui]') || drawer?.querySelector('[data-omni-cart-ui]');
    const element = root?.querySelector('[data-cart-error]');
    if (element) element.textContent = message;
  }
  function setBusy(value) {
    busy = value;
    roots().forEach(root => {
      root.setAttribute('aria-busy', String(value));
      root.querySelectorAll('button:not([data-omni-cart-close]),input').forEach(element => element.disabled = value);
      root.querySelectorAll('.omni-cart-ui__checkout').forEach(element => {
        if (value) element.setAttribute('aria-disabled', 'true');
        else element.removeAttribute('aria-disabled');
      });
    });
  }
  function makeRow(item, cart) {
    const title = item.product_title || item.title;
    const subscription = isClub(item);
    const allocation = item.selling_plan_allocation;
    const plan = allocation?.selling_plan;
    const purchaseLabel = subscription ? 'Suscripción OmniClub' : 'Compra única';
    const accessibleTitle = `${title}, ${purchaseLabel}`;
    const row = node('article', `omni-cart-ui__item${subscription ? ' is-subscription' : ''}`);
    row.dataset.cartKey = item.key;
    row.dataset.cartPurchaseType = subscription ? 'subscription' : 'one-time';
    const photo = node('a', 'omni-cart-ui__photo');
    photo.href = safeUrl(item.url, routeRoot);
    photo.tabIndex = -1;
    photo.setAttribute('aria-hidden', 'true');
    if (item.image) {
      const image = node('img');
      image.src = safeUrl(item.image, '');
      image.alt = title;
      image.loading = 'lazy';
      photo.append(image);
    }
    const body = node('div', 'omni-cart-ui__item-body');
    const link = node('a', 'omni-cart-ui__item-title', title);
    link.href = safeUrl(item.url, routeRoot);
    body.append(link, node('span', 'omni-cart-ui__type', purchaseLabel));
    if (subscription) {
      const deliveryPrice = (allocation.per_delivery_price ?? allocation.price) * item.quantity;
      body.append(node('span', 'omni-cart-ui__plan-price', `${money(deliveryPrice, cart.currency)} por entrega`));
      const renewal = String(plan.id) === '692765327655'
        ? 'Renovación automática cada 2 meses'
        : plan.recurring_deliveries ? `Renovación automática · ${plan.name}` : plan.name;
      body.append(node('span', 'omni-cart-ui__plan-note', renewal));
    } else {
      body.append(node('span', 'omni-cart-ui__plan-note', 'Un solo pago · Sin renovación'));
    }
    if (!item.product_has_only_default_variant && item.variant_title) body.append(node('small', '', item.variant_title));
    const remove = node('button', 'omni-cart-ui__remove', '×');
    remove.type = 'button';
    remove.dataset.cartRemove = '';
    remove.setAttribute('aria-label', `Eliminar ${accessibleTitle}`);
    body.append(remove);
    const bottom = node('div', 'omni-cart-ui__item-bottom');
    const quantity = node('div', 'omni-cart-ui__quantity');
    const minus = node('button', '', '−');
    minus.type = 'button';
    minus.dataset.cartStep = '-1';
    minus.setAttribute('aria-label', `Reducir cantidad de ${accessibleTitle}`);
    const input = node('input');
    input.type = 'number';
    input.min = '0';
    input.step = '1';
    input.value = item.quantity;
    input.dataset.cartQuantity = '';
    input.setAttribute('aria-label', `Cantidad de ${accessibleTitle}`);
    const plus = node('button', '', '+');
    plus.type = 'button';
    plus.dataset.cartStep = '1';
    plus.setAttribute('aria-label', `Aumentar cantidad de ${accessibleTitle}`);
    quantity.append(minus, input, plus);
    bottom.append(quantity, node('strong', 'omni-cart-ui__price', money(item.final_line_price, cart.currency)));
    body.append(bottom);
    const allocations = item.line_level_discount_allocations || [];
    if (allocations.length) body.append(node('small', 'omni-cart-ui__item-discount', allocations.map(allocation => allocation.discount_application.title).join(' · ')));
    row.append(photo, body);
    return row;
  }
  function render(cart) {
    lastCart = cart;
    roots().forEach(root => {
      const items = root.querySelector('[data-cart-items]');
      if (items) items.replaceChildren(...cart.items.map(item => makeRow(item, cart)));
      const empty = root.querySelector('[data-cart-empty]');
      if (empty) empty.hidden = Boolean(cart.item_count);
      const summary = root.querySelector('[data-cart-summary]');
      if (summary) summary.hidden = !cart.item_count;
      const total = root.querySelector('[data-cart-total]');
      if (total) total.textContent = money(cart.total_price, cart.currency);
      const count = root.querySelector('[data-cart-item-count]');
      if (count) count.textContent = `(${cart.item_count} ${cart.item_count === 1 ? 'producto' : 'productos'})`;
      const discounts = root.querySelector('[data-cart-discounts]');
      if (discounts) {
        discounts.replaceChildren(...(cart.cart_level_discount_applications || []).map(discount => {
          const row = node('div');
          const application = discount.discount_application || discount;
          const amount = discount.amount ?? application.total_allocated_amount;
          row.append(node('span', '', application.title), node('strong', '', `−${money(amount, cart.currency)}`));
          return row;
        }));
      }
      const codeList = root.querySelector('[data-cart-codes]');
      if (codeList) codeList.replaceChildren(...codes(cart).map(code => {
        const chip = node('span', 'omni-cart-ui__code');
        const remove = node('button', '', '×');
        remove.type = 'button';
        remove.dataset.cartRemoveCode = code;
        remove.setAttribute('aria-label', `Quitar cupón ${code}`);
        chip.append(node('span', '', code), remove);
        return chip;
      }));
      root.querySelectorAll('.omni-cart-ui__checkout').forEach(link => {
        link.dataset.omniCartValue = units(cart.total_price);
        link.dataset.omniCurrency = cart.currency;
        link.dataset.omniItemCount = cart.item_count;
        link.dataset.omniPurchaseTypes = purchaseTypes(cart).join(',');
      });
    });
    setCount(cart);
    setBusy(busy);
    window.dispatchEvent(new CustomEvent('omni:cart-updated', { detail: { cart } }));
  }
  async function request(path, body) {
    const response = await fetch(routeRoot + path, {
      method: body ? 'POST' : 'GET',
      headers: body ? { Accept: 'application/json', 'Content-Type': 'application/json' } : { Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'No pudimos actualizar el carrito. Inténtalo de nuevo.');
    return result;
  }
  const fetchCart = () => request('cart.js');
  async function changeQuantity(source, quantity) {
    if (busy) return;
    const row = source.closest('[data-cart-key]');
    const root = source.closest('[data-omni-cart-ui]');
    if (!row || !Number.isInteger(quantity) || quantity < 0) return;
    const key = row.dataset.cartKey;
    root.querySelector('[data-cart-error]').textContent = '';
    const itemIndex = lastCart?.items.findIndex(item => item.key === key);
    setBusy(true);
    try {
      const cart = await request('cart/change.js', { id: key, quantity });
      render(cart);
      const updatedRow = root.querySelectorAll('[data-cart-key]')[Math.min(itemIndex < 0 ? 0 : itemIndex, cart.items.length - 1)];
      setBusy(false);
      (updatedRow?.querySelector('[data-cart-quantity]') || root.querySelector('[data-cart-empty] a'))?.focus();
    } catch (failure) {
      errorMessage(failure.message, source);
      try { render(await fetchCart()); } catch {}
    } finally { setBusy(false); }
  }
  async function applyDiscount(form, removeCode) {
    if (busy) return;
    const root = form.closest('[data-omni-cart-ui]');
    const input = form.querySelector('[name="discount"]');
    const status = form.querySelector('[data-cart-discount-status]');
    const entered = input.value.trim();
    if (!removeCode && !entered) { input.focus(); return; }
    const before = lastCart || await fetchCart();
    const oldCodes = codes(before);
    const requested = removeCode ? oldCodes.filter(code => !same(code, removeCode)) : [...new Set([...oldCodes, entered])];
    status.classList.remove('is-error');
    status.textContent = removeCode ? 'Quitando cupón…' : 'Comprobando código…';
    setBusy(true);
    try {
      let cart = await request('cart/update.js', { discount: requested.join(',') });
      render(cart);
      const accepted = codes(cart).some(code => same(code, entered));
      const applications = [...(cart.cart_level_discount_applications || []).map(discount => discount.discount_application || discount), ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
      const recognized = accepted || applications.some(discount => discount.type === 'discount_code' && same(discount.title, entered));
      if (removeCode) {
        status.textContent = 'Cupón eliminado.';
      } else if (recognized) {
        status.textContent = 'Código aplicado. El total está actualizado.';
        input.value = '';
      } else {
        status.classList.add('is-error');
        status.textContent = 'Este código no es válido o no aplica a los productos de tu carrito.';
        cart = await request('cart/update.js', { discount: oldCodes.join(',') });
        render(cart);
      }
    } catch (failure) {
      status.classList.add('is-error');
      status.textContent = failure.message;
    } finally { setBusy(false); }
  }
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-omni-cart-close]')) { close(); return; }
    const opener = event.target.closest('[data-omni-cart-open]');
    if (opener) {
      event.preventDefault();
      open();
      try {
        const cart = await fetchCart();
        render(cart);
        errorMessage('', drawer.querySelector('[data-omni-cart-ui]'));
        emit('view_cart', { value: units(cart.total_price), currency: cart.currency, item_count: cart.item_count });
      } catch (failure) { errorMessage(failure.message, drawer.querySelector('[data-omni-cart-ui]')); }
      return;
    }
    const step = event.target.closest('[data-cart-step]');
    if (step) {
      const input = step.closest('[data-cart-key]').querySelector('[data-cart-quantity]');
      changeQuantity(step, Math.max(0, Number(input.value) + Number(step.dataset.cartStep)));
      return;
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { changeQuantity(remove, 0); return; }
    const removeCode = event.target.closest('[data-cart-remove-code]');
    if (removeCode) {
      const root = removeCode.closest('[data-omni-cart-ui]');
      root.querySelector('[data-cart-coupon]').open = true;
      applyDiscount(root.querySelector('[data-cart-discount-form]'), removeCode.dataset.cartRemoveCode);
      return;
    }
    const checkout = event.target.closest('.omni-cart-ui__checkout,.omni-cart-drawer__checkout,.omni-cart-page__checkout');
    if (checkout) {
      if (busy) { event.preventDefault(); return; }
      if (lastCart) emit('begin_checkout', { value: units(lastCart.total_price), currency: lastCart.currency, item_count: lastCart.item_count, purchase_types: purchaseTypes(lastCart) });
      else emit('begin_checkout', { value: Number(checkout.dataset.omniCartValue || 0), currency: checkout.dataset.omniCurrency || 'MXN', item_count: Number(checkout.dataset.omniItemCount || 0), purchase_types: (checkout.dataset.omniPurchaseTypes || '').split(',').filter(Boolean) });
    }
    const route = event.target.closest('[data-omni-event="select_routine"]');
    if (route) emit('select_routine', { routine: route.dataset.omniRoutine || '', placement: 'home' });
    const checkin = event.target.closest('[data-omni-incident-submit]');
    if (checkin) {
      const form = checkin.closest('form');
      emit('report_incident', { routine: form?.querySelector('[name="contact[Routine]"]')?.value || '', lot_present_boolean: Boolean(form?.querySelector('[name="contact[Lot]"]')?.value.trim()) });
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-quantity]')) {
      const quantity = Number(event.target.value);
      if (Number.isInteger(quantity) && quantity >= 0) changeQuantity(event.target, quantity);
      else { errorMessage('Introduce una cantidad válida.', event.target); if (lastCart) render(lastCart); }
    }
  });
  document.addEventListener('keydown', event => {
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const items = focusable();
    if (!items.length) { event.preventDefault(); drawer.focus(); return; }
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('submit', async event => {
    if (event.target.matches('[data-cart-discount-form]')) { event.preventDefault(); await applyDiscount(event.target); return; }
    const form = event.target.closest('.omni-product-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
    try {
      const response = await fetch(routeRoot + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const item = await response.json();
      if (!response.ok) throw new Error(item.description || 'No pudimos añadir el producto.');
      const club = isClub(item), plan = item.selling_plan_allocation?.selling_plan;
      emit('add_to_cart', { product_id: item.product_id, variant_id: item.variant_id, sku: item.sku || '', routine: item.properties?._omni_route || '', purchase_type: club ? 'OMNICLUB' : 'ONE_TIME', price: units(item.final_price), currency: window.OmniShop?.currency || 'MXN', selling_plan_id: plan?.id || null, discount: units(Math.max(0, (item.original_line_price || item.final_line_price) - item.final_line_price)) });
      render(await fetchCart());
      open();
    } catch (failure) { errorMessage(failure.message); open(); }
    finally { if (button) button.disabled = false; }
  });
  if (document.querySelector('[data-cart-mode="page"]')) fetchCart().then(render).catch(() => {});
  if (window.OmniShop?.pageType === 'index') emit('view_home', { page_template: 'index' });
})();
